import React, { useEffect, useState } from "react";

import { PricingGrid } from "../../constants/Pricing";
import classNames from "classnames";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchPricingPlans,
  changePricingPlan,
  selectPricingPlan,
} from "../../redux/actions/pricingGridAction";
import { rocketIcon } from "../../constants/Images";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function Plans() {
  const { pricingPlans } = useSelector((state) => state);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState({});
  const [isUpgrade, setIsUpgrade] = useState(false);
  const dispatch = useDispatch();

  const getParams = () => {
    const queryString = window.location.search;
    let str = queryString.substring(1);
    let queryarr = str.split("&&");
    let obj = {};
    for (let i = 0; i < queryarr.length; i++) {
      let str = queryarr[i];
      let strS = str.split("=");
      obj[strS[0]] = decodeURI(strS[1]);
    }
    setSelectedPlanDetails(obj);
  };


  useEffect(() => {
    dispatch(fetchPricingPlans());
    getParams();
  }, []);

  useEffect(() => {
     if(selectedPlanDetails.method) {
      setIsUpgrade(true)
     }
  }, [selectedPlanDetails]);

  

  const scope = pricingPlans;

  const changePlan = (durationType) => {
    dispatch(changePricingPlan(durationType));
  };

  const selectPlan = (item, i, mainindex) => {
    dispatch(selectPricingPlan(item, i, mainindex));
    /*  if (i == 1) {
            scope.row = scope.items[i].products[i].name;
            scope.display_price = item[scope.interval].display_price;
            scope.display_code  = item[scope.interval].code
          } else if(i == 2){
            scope.row2 = scope.items[i].products[i].name;
            scope.display_price2 = item[scope.interval].display_price;
            scope.display_code2  = item[scope.interval].code
          }else{
            scope.row3 = scope.items[i].products[i].name;
            scope.display_price3 = item[scope.interval].display_price;
            scope.display_code3  = item[scope.interval].code
          } */
  };

  const handleSamePlan = (event, code) => {
    if (selectedPlanDetails.plan_id === code) {
      event.preventDefault()
      toast.warn("You are on the same plan. Please choose another.")
    } else {
      return true;
    }
  }

  return (
    <section className="white-bg PricingDealSection ">
      <div className="clearfix p-4">
        <div className="clearfix">
          {
            selectedPlanDetails.method && <div className="currentPricingPlan">
            <h3>Your Current Plan : <b>{selectedPlanDetails.name}</b> | <span className="plandes">{selectedPlanDetails.subscription} <span className="text-capitalize">{`${selectedPlanDetails.type}ly`}</span></span></h3>
          </div>
          }
          <div className="clearfix mb60 width-90">
            <div className="clearfix">
              <h2 className="pricing_h1">
                Affordable and Scalable Pricing{" "}
                <img
                  src={rocketIcon}
                  alt="Rocket"
                />
              </h2>
              <div className="row align-items-center switch_margin no-gutters">
                <div>
                  <ul className="priceswitching clearfix">
                    <li
                      className={
                        "" +
                        classNames({
                          active: scope.interval === "year",
                        })
                      }
                      onClick={() => changePlan("year")}
                    >
                      <span className="switch_a">Annual</span>
                      <input
                        type="radio"
                        id="Annual"
                        value="Annual"
                        name="pricingtype"
                        className="radioPricingInut"
                        checked
                      />
                    </li>
                    <li
                      className={
                        "" +
                        classNames({
                          active: scope.interval === "month",
                        })
                      }
                      onClick={() => changePlan("month")}
                    >
                      <span className="switch_a">Monthly</span>
                      <input
                        type="radio"
                        id="Monthly"
                        value="Monthly"
                        name="pricingtype"
                        className="radioPricingInut"
                      />
                    </li>
                  </ul>
                </div>
                <div className="col">
                  <h2 className="pricing_sub_heading">
                    <b>Save Upto 20% </b>by subscribing to annual plans
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="row pricingpage_colrow loading">
            {scope.items.map((item, index) => {
              return (
                <div
                  className={
                    "col-sm-3 pricingcol " +
                    classNames({
                      lite_pricing_plan: item.id == 1,
                      enterprise_pricing_plan: item.id == 1,
                      live_pricing_plan: item.id == 2,
                      mostpopularpricecol: item.id == 3,
                      webautomation_pricing_plan: item.id == 4,
                    })
                  }
                >
                  <div className="clearfix PricingDealbox">
                    {item.id == 3 ? (
                      <span className="mostpopularheading">Most Popular</span>
                    ) : null}

                    <div className="pricinginfocontainer">
                      {item.id != 3 ? <h4>{item.name}</h4> : null}
                      {item.id == 3 ? <h4>{item.name}</h4> : null}
                      {item.id == 3 || item.id == 4 ? (
                        <p className="includeslive">Includes Live</p>
                      ) : null}

                      {scope.interval == "year" ? (
                        <div>
                          {index == 1 ? (
                            <h2>
                              <span className="originalprice">
                                ${scope.display_price}
                              </span>
                            </h2>
                          ) : null}

                          {index == 2 ? (
                            <h2>
                              <span className="originalprice">
                                ${scope.display_price2}
                              </span>
                            </h2>
                          ) : null}
                          {index == 3 ? (
                            <h2>
                              <span className="originalprice">
                                ${scope.display_price3}
                              </span>
                            </h2>
                          ) : null}
                        </div>
                      ) : null}
                      {scope.interval == "month" ? (
                        <div>
                          {index == 1 ? (
                            <h2>
                              <span className="originalprice">
                                ${scope.display_price}
                              </span>
                            </h2>
                          ) : null}

                          {index == 2 ? (
                            <h2>
                              <span className="originalprice">
                                ${scope.display_price2}
                              </span>
                            </h2>
                          ) : null}
                          {index == 3 ? (
                            <h2>
                              <span className="originalprice">
                                ${scope.display_price3}
                              </span>
                            </h2>
                          ) : null}
                        </div>
                      ) : null}

                      {scope.interval == "year" ? (
                        <p className="permonthbilledtext_landing">
                          Per Month (Billed Annually)
                        </p>
                      ) : null}

                      {scope.interval == "month" ? (
                        <p className="permonthbilledtext_landing">Per Month</p>
                      ) : null}

                      {item.id == 1 ? (
                        <div className="clearfix text-center">
                          <a
                            href="https://www.lambdatest.com/contact-us"
                            className="btn btn-dark btn-flat text-uppercase"
                            target="_blank"
                          >
                            Contact Sales
                          </a>
                        </div>
                      ) : null}

                      {
                        !isUpgrade && <> {item.id == 2 && scope.interval == "month" ? (
                          <div className="clearfix text-center">
                            <Link
                              to={`/checkout?plan=${scope.display_code}&&name=${item.name}&&price=${scope.display_price}&&subscription=${scope.row}&&type=${scope.interval}`}
                              className="btn btn-dark btn-flat text-uppercase"
                            >
                              Get Started
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 3 && scope.interval == "month" ? (
                          <div className="clearfix text-center">
                            <Link
                              to={`/checkout?plan=${scope.display_code2}&&name=${item.name}&&price=${scope.display_price2}&&subscription=${scope.row2}&&type=${scope.interval}`}
                              className="btn btn-dark btn-flat text-uppercase"
                            >
                              Get Started
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 4 && scope.interval == "month" ? (
                          <div className="clearfix text-center">
                            <Link
                              to={`/checkout?plan=${scope.display_code3}&&name=${item.name}&&price=${scope.display_price3}&&subscription=${scope.row3}&&type=${scope.interval}`}
                              className="btn btn-dark btn-flat text-uppercase"
                            >
                              Get Started
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 2 && scope.interval == "year" ? (
                          <div className="clearfix text-center">
                            <Link
                              to={`/checkout?plan=${scope.display_code}&&name=${item.name}&&price=${scope.display_price}&&subscription=${scope.row}&&type=${scope.interval}`}
                              className="btn btn-dark btn-flat text-uppercase"
                            >
                              Get Started
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 3 && scope.interval == "year" ? (
                          <div className="clearfix text-center">
                            <Link
                              to={`/checkout?plan=${scope.display_code2}&&name=${item.name}&&price=${scope.display_price2}&&subscription=${scope.row2}&&type=${scope.interval}`}
                              className="btn btn-dark btn-flat text-uppercase"
                            >
                              Get Started
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 4 && scope.interval == "year" ? (
                          <div className="clearfix text-center">
                            <Link
                              to={`/checkout?plan=${scope.display_code3}&&name=${item.name}&&price=${scope.display_price3}&&subscription=${scope.row3}&&type=${scope.interval}`}
                              className="btn btn-dark btn-flat text-uppercase"
                            >
                              Get Started
                            </Link>
                          </div>
                        ) : null}</>
                      }

                      {item.id == 1 ? (
                        <p className="conCurrent">25+ Parallel Sessions</p>
                      ) : null}

                      <div className="select-box">
                        {item.products.length === 1 ? (
                          <span className="lite_form_control">
                            1 Parallel Test (5 Users)
                          </span>
                        ) : null}
                        {item.products.length != 1 ? (
                          <div>
                            {index == 1 ? (
                              <UncontrolledDropdown>
                                <DropdownToggle>{scope.row}</DropdownToggle>
                                <DropdownMenu>
                                  {item.products.map((item, i) => {
                                    return (
                                      <DropdownItem
                                        onClick={() =>
                                          selectPlan(item, i, index)
                                        }
                                      >
                                        {item.name}
                                      </DropdownItem>
                                    );
                                  })}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            ) : null}

                            {index == 2 ? (
                              <UncontrolledDropdown>
                                <DropdownToggle>{scope.row2}</DropdownToggle>
                                <DropdownMenu>
                                  {item.products.map((item, i) => {
                                    return (
                                      <DropdownItem
                                        onClick={() =>
                                          selectPlan(item, i, index)
                                        }
                                      >
                                        {item.name}
                                      </DropdownItem>
                                    );
                                  })}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            ) : null}

                            {index == 3 ? (
                              <UncontrolledDropdown>
                                <DropdownToggle>{scope.row3}</DropdownToggle>
                                <DropdownMenu>
                                  {item.products.map((item, i) => {
                                    return (
                                      <DropdownItem
                                        onClick={() =>
                                          selectPlan(item, i, index)
                                        }
                                      >
                                        {item.name}
                                      </DropdownItem>
                                    );
                                  })}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
 

                      {item.id == 2 || item.id == 1 ? (
                        <div className="paralleltest">
                          <p
                            className="moreInfoTooltip"
                            id={"Tooltip-useragent-" + item.id}
                          >
                            What are parallel tests?
                          </p>
                          <UncontrolledTooltip
                            placement="bottom"
                            target={"Tooltip-useragent-" + item.id}
                            autohide={false}
                          >
                            Parallel tests indicate the number of users who can
                            perform testing simultaneously.
                          </UncontrolledTooltip>{" "}
                        </div>
                      ) : null}

                        {item.id == 3 || item.id == 4 ? (
                        <div className="paralleltest">
                          <p
                            className="moreInfoTooltip"
                            id={"Tooltip-useragent-" + item.id}
                          >
                            What are parallel tests?
                          </p>
                          <UncontrolledTooltip
                            placement="bottom"
                            target={"Tooltip-useragent-" + item.id}
                            autohide={false}
                          >
                           Parallel tests indicate the number of automated tests that run be run at the same time. <br /> <a href="https://www.lambdatest.com/concurrency-calculator/" target="_blank" style={{color: "#90dcff"}}>Calculate how many you need</a>
                          </UncontrolledTooltip>{" "}
                        </div>
                      ) : null}
 
                    </div>

                    {item.id !== 1 ? (
                      <ul className="pricingfeatures">
                        {" "}
                        {item.products[0][scope.interval].features.map(
                          (feature, index) => {
                            return (
                              <li
                                dangerouslySetInnerHTML={{
                                  __html: feature.name,
                                }}
                              ></li>
                            );
                          }
                        )}
                      </ul>
                    ) : null}

                    {item.id == 1 ? (
                      <ul className="pricingfeatures">
                        <li>Unlimited Browser Automation Testing</li>
                        <li>Unlimited Realtime Browser Testing</li>
                        <li>24*7 expert tech support</li>
                        <li>3rd Party App Integrations</li>
                        <li>Unlimited Screenshot Testing</li>
                        <li>Unlimited Responsive Testing</li>
                        <li>Dedicated account manager</li>
                        <li>
                          <a
                            href="https://www.lambdatest.com/mobile-app-testing"
                            target="_blank"
                          >
                            Native Mobile App Testing
                          </a>
                        </li>
                      </ul>
                    ) : null}

                    {
                        isUpgrade && <> {item.id == 2 && scope.interval == "month" ? (
                          <div className="clearfix text-center upgradeButton">
                            <Link
                              to={`/switch-plan?plan=${scope.display_code}&&method=${selectedPlanDetails.method}&&name=${item.name}&&subscription=${scope.row}`}
                              className="btn btn-dark btn-flat text-uppercase"
                              onClick={(event) => handleSamePlan(event, scope.display_code)}
                            >
                              Switch Plan
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 3 && scope.interval == "month" ? (
                          <div className="clearfix text-center upgradeButton">
                            <Link
                              to={`/switch-plan?plan=${scope.display_code2}&&method=${selectedPlanDetails.method}&&name=${item.name}&&subscription=${scope.row2}`}
                              className="btn btn-dark btn-flat text-uppercase"
                              onClick={(event) => handleSamePlan(event, scope.display_code2)}
                            >
                              Switch Plan
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 4 && scope.interval == "month" ? (
                          <div className="clearfix text-center upgradeButton">
                            <Link
                              to={`/switch-plan?plan=${scope.display_code3}&&method=${selectedPlanDetails.method}&&name=${item.name}&&subscription=${scope.row3}`}
                              className="btn btn-dark btn-flat text-uppercase"
                              onClick={(event) => handleSamePlan(event, scope.display_code3)}
                            >
                             Switch Plan
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 2 && scope.interval == "year" ? (
                          <div className="clearfix text-center upgradeButton">
                            <Link
                              to={`/switch-plan?plan=${scope.display_code}&&method=${selectedPlanDetails.method}&&name=${item.name}&&subscription=${scope.row}`}
                              className="btn btn-dark btn-flat text-uppercase"
                              onClick={(event) => handleSamePlan(event, scope.display_code)}
                            >
                             Switch Plan
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 3 && scope.interval == "year" ? (
                          <div className="clearfix text-center upgradeButton">
                            <Link
                              to={`/switch-plan?plan=${scope.display_code2}&&method=${selectedPlanDetails.method}&&name=${item.name}&&subscription=${scope.row2}`}
                              className="btn btn-dark btn-flat text-uppercase"
                              onClick={(event) => handleSamePlan(event, scope.display_code2)}
                            >
                              Switch Plan
                            </Link>
                          </div>
                        ) : null}
  
                        {item.id == 4 && scope.interval == "year" ? (
                          <div className="clearfix text-center upgradeButton">
                            <Link
                              to={`/switch-plan?plan=${scope.display_code3}&&method=${selectedPlanDetails.method}&&name=${item.name}&&subscription=${scope.row3}`}
                              className="btn btn-dark btn-flat text-uppercase"
                              onClick={(event) => handleSamePlan(event, scope.display_code3)}
                            >
                             Switch Plan
                            </Link>
                          </div>
                        ) : null}</>
                      }
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
